import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getBundleInWard = (page, pagesize, search, id, ordering, start_date, end_date) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/bundle-inward/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
      ...(start_date && { start_date: start_date }),
      ...(end_date && { end_date: end_date }),
    },
  });
};

const getBundleInWardByItem = (page, pagesize, search, id, ordering, workOrderId) => {
  return axios.get(
    API_URL +
    '/api/' +
    API_VERSION +
    `/bundle-inward/${workOrderId}/bundle-inward-by-workorder/`,
    {
      headers: authHeader(),
      params: {
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};

const getBundleInWardByWorkorderItemWise = (page, pagesize, search, id, ordering, selectedId) => {
  return axios.get(API_URL +'/api/' + API_VERSION +`/bundle-inward/${selectedId}/bundle-inward-by-workorder-detail/`,
    {
      headers: authHeader(),
      params: {
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};

const getBundleInWardStatusByItem = (
  page,
  pagesize,
  search,
  workOrderId,
  ordering,
  selectedId,
) => {
  return axios.get(
    API_URL +
    '/api/' +
    API_VERSION +
    `/workorder/${workOrderId}/get-workorder-details-summery/`,
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        detail_ids: selectedId,
        ordering: ordering,
      },
    },
  );
};
const getCustomerConversion = (
  page,
  pagesize,
  search,
  customer_id,
  ordering,
) => {
  return axios.get(
    API_URL +
    '/api/' +
    API_VERSION +
    '/customer/get-conversion-rate-by-customer/',
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        customer_id: customer_id,
        ordering: ordering,
      },
    },
  );
};


const getWorkOrderListInBundleInward = (page, pagesize, search) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/', {
    headers: authHeader(),
    params: {
      //fields: 'id,order_no, order_date, purchase_order_no, purchase_order_date, bill_to__customer_name,status,,remarks',
      page: page,
      pagesize: pagesize,
      search: search,
    },
  });
};

const getBundleInWardById = id => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/bundle-inward/inward-party-print/?bundle_inward_id=${id}`,
    {
      headers: authHeader(),
    },
  );
};
const getBundleStatusWarehouseSummary  = id => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/bundle-inward/${id}/delete-summary`, 
    {
      headers: authHeader(),
    },
  );
};
const deleteBundleinwardList = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/bundle-inward/${id}/`, 
    {
      headers: {
        ...authHeader()
      },
    },
  );
};
const addBundleInWard = values => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/bundle-inward/`,
    values, // Payload for the request body
    { headers: authHeader() },
  );
};

const shiftBundleExcessStock = async sizeData => {
  try {
    const response = await axios.post(
      `${API_URL}/api/${API_VERSION}/excess-stock/shift-bundles-excess-stock/`,
      sizeData,
      {
        headers: authHeader(),
      },
    );
    return response.data; // Assuming the response contains the created die size data
  } catch (error) {
    console.error('Error creating die size:', error);
    throw error; // Ensure proper error handling
  }
};

const BundleInwardServices = {
  getBundleInWard,
  getBundleStatusWarehouseSummary,
  deleteBundleinwardList,
  getCustomerConversion,
  addBundleInWard,
  getBundleInWardById,
  shiftBundleExcessStock,
  getWorkOrderListInBundleInward,
  getBundleInWardByItem,
  getBundleInWardByWorkorderItemWise,
  getBundleInWardStatusByItem,
};

export default BundleInwardServices;
